import styled from 'styled-components';

export const Title = styled.h1`
  font-family: 'Staatliches';
  color: #EB8A26;
  line-height: 60px;
  font-size: 70px;
  max-width: 650px;
  margin:0px auto 25px auto;
  text-align: center;
`;

export const Button = styled.button`
  background-color: #576B7A;
  font-weight: bold;
  padding: 16px 30px 16px 30px;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  border: none;
  margin-top: 20px;
`;

export const IntroText = styled.p`
  font-family: 'Raleway', sans-serif;
  color: white;
  white-space: pre-wrap;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  text-align: left;
`;

export const Columns = styled.div`
   column-count: 2;
   column-gap: 40px;
   column-width: 250px;
   @media (max-width: 935px) {
    column-count: 1;
    margin: 0 16px 0 16px;
  }
`

export const LogoStyle = styled.img`
  width: 250px;
  height: auto;
  margin: 25px 0 25px 0;
`;
